/**
 * Helpers de formato de fecha respetando la zona horaria activa del usuario.
 *
 * Convención del proyecto:
 *  - Toda fecha en DB y en payloads de la API está en UTC.
 *  - El frontend muestra fechas en la TZ del usuario (TimezoneContext).
 *  - Para mostrar SIEMPRE usar formatInTz / formatDate / formatDateTime,
 *    NO `new Date(x).toLocaleDateString()` ni `dayjs(x).format()` directos
 *    (esos usan la TZ del navegador y NO respetan la elección del usuario).
 */
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

export const DEFAULT_DATETIME_FORMAT = 'YYYY-MM-DD HH:mm';
export const DEFAULT_DATE_FORMAT = 'YYYY-MM-DD';

/**
 * Formatea una fecha (Date | ISO string | epoch ms) en la TZ dada.
 * @param {*} input
 * @param {string} tz IANA timezone (ej. 'America/Montevideo')
 * @param {string} format dayjs format
 */
export function formatInTz(input, tz, format = DEFAULT_DATETIME_FORMAT) {
  if (input == null || input === '') return '';
  const d = dayjs(input);
  if (!d.isValid()) return '';
  return d.tz(tz).format(format);
}

export function formatDate(input, tz) {
  return formatInTz(input, tz, DEFAULT_DATE_FORMAT);
}

export function formatDateTime(input, tz) {
  return formatInTz(input, tz, DEFAULT_DATETIME_FORMAT);
}

/**
 * Devuelve el offset textual de una TZ ahora mismo (ej. "UTC-3", "UTC-5").
 */
export function tzOffsetLabel(tz) {
  try {
    const offsetMinutes = dayjs().tz(tz).utcOffset();
    const sign = offsetMinutes >= 0 ? '+' : '-';
    const abs = Math.abs(offsetMinutes);
    const h = Math.floor(abs / 60);
    const m = abs % 60;
    return `UTC${sign}${h}${m ? ':' + String(m).padStart(2, '0') : ''}`;
  } catch {
    return tz;
  }
}
